import { isBlank, getStringFromAny } from '@autobest-ui/utils';
import Logger from '@autobest-ui/client-logger';
import { isDev } from '../validate';

const FilterFetchList = [
  'Failed to fetch',
  'Network request failed',
  'cancelled',
  'Aborted',
  'The network connection was lost',
  'NetworkError when attempting to fetch resource'
];

/**
 * Fetch日志参数设置
 */
export default function trackDependency({ options, url, response, duration }) {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.warn({ options, url, response, duration });
    return;
  }

  // 无权限
  if (response.code === 401 || response.code === 403) {
    return;
  }

  const responseCode = !isBlank(response.code)
    ? response.code
    : !isBlank(response.status)
    ? response.status
    : 0;

  if (responseCode === 0) {
    return;
  }

  const message = getStringFromAny(response);

  const findIndex = FilterFetchList.findIndex(
    item => message.indexOf(item) !== -1
  );
  // 这块过滤掉
  if (findIndex !== -1) {
    return;
  }

  const data = {
    duration,
    method: options.method.toUpperCase(),
    requestUrl: url,
    responseCode: responseCode,
    logkey: options.headers.logkey,
    headers: JSON.stringify(options.headers),
    response: JSON.stringify(response)
  };

  Logger.trackDependency(data);
}
